import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "./LoginModal";
import esriId from "@arcgis/core/identity/IdentityManager";
import Portal from "@arcgis/core/portal/Portal";
import StateContext from "../contexts/StateContext";
import DispatchContext from "../contexts/DispatchContext";
import { Card, Spinner } from "react-bootstrap";


const Login = () => {
    const navigate = useNavigate();

    const GlobalState = useContext(StateContext);
    const GlobalDispatch = useContext(DispatchContext);

    const [ifShow, setIfShow] = useState(true);
    // to maintain the value between reloads and to check if the user has attempted to sign in before
    const [ifAttemptSignIn, setIfAttemptSignIn] = useState(() => {
        return localStorage.getItem('ifAttemptSignIn') === 'true';
    });
    const [isLoading, setIsLoading] = useState(true);

    const imageBackgroundStyle =
        {
            backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/patrick-langwallner-Ig2cLTewvP4-unsplash.jpg)`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat"
        };

    const handleClickForSignIn = () =>{
        setIfShow(false);
        setIfAttemptSignIn(true);
        localStorage.setItem('ifAttemptSignIn', 'true'); // set the value to true in local storage
        esriId.getCredential((GlobalState.authInfoState).portalUrl + "/sharing");
        // it redirects to the login page immediately after the above line, so we need to set a delay later
        // to make sure the credential is fetched
    }

    useEffect(
        () => {
            // runs an authentication check
            const checkAuthStatus = async () => {
                try {
                    await esriId.checkSignInStatus((GlobalState.authInfoState).portalUrl + "/sharing");
                    console.log("i am checking auth status.")
                    await handleSignedIn();
                } catch {
                    handleSignedOut();
                } finally {
                    setIsLoading(false); // stop loading once the check is complete
                }
            };

            if (ifAttemptSignIn) {
                // if the user has attempted to sign in before, check the authentication status with a delay
                // a delay is needed to make sure the credential is fetched
                console.log("Second attempt to check auth status.")
                setTimeout(()=>{checkAuthStatus()}, 1000)
            } else {
                console.log("First attempt to check auth status.")
                // if the user has not attempted to sign in before, check the authentication status immediately
                checkAuthStatus()
            };

            async function handleSignedIn() {
                const portal = new Portal();
                // Check if using a portal other than ArcGIS Online.
                if ((GlobalState.authInfoState).portalUrl !== "https://www.arcgis.com"){
                    portal.url = (GlobalState.authInfoState).portalUrl
                }
                portal.load().then(() => {
                    GlobalDispatch({type: "userLogin", name: portal.user.fullName, username: portal.user.username})
                    navigate("/analyse");
                });
            }

            function handleSignedOut() {
                setIfAttemptSignIn(false);
                localStorage.setItem('ifAttemptSignIn', 'false'); // set the value to false in local storage
                GlobalDispatch({type:"userLogout"});
                esriId.destroyCredentials();
                sessionStorage.clear();
            }
        }, []
    );

    if (isLoading) {
        return (
            // show loading indicator while authentication is in progress
            <div style={{width: "100%", height:"100%"}}>
                <Card className="text-center" style={{ width: "40%", top: "30%", left: "30%" }}>
                    <Card.Body className="mt-4">
                        <Spinner animation="border" role="status" variant="secondary"></Spinner>
                        <h5 className="p-2">Loading...</h5>
                    </Card.Body>
                </Card>
            </div>
        );
    }

    return (<div className="startingPicDiv" style={imageBackgroundStyle}>
                    <small className="px-2 img-footer w-100"> Photo by <a
                        href="https://unsplash.com/@patresinger?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
                        style={{ color: "#666666", textDecoration: "underline" }}>Patrick Langwallner</a> on <a
                        href="https://unsplash.com/photos/a-city-with-a-river-running-through-it-Ig2cLTewvP4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
                        style={{ color: "#666666", textDecoration: "underline" }}>Unsplash</a></small>
                    <LoginModal ifShow={ifShow} handleClickForSignIn={handleClickForSignIn}/>
                </div>)
}

export default Login;
